import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["data-invalid"]
const _hoisted_2 = {
  for: "name",
  class: "transport-stop-form__field-label col-0-8 main-m font-m align-r"
}
const _hoisted_3 = {
  key: 0,
  class: "main-alert font-size-14 transport-stop-form__field-error"
}
const _hoisted_4 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_5 = { class: "h-full item-center justify-center" }
const _hoisted_6 = {
  class: "form-modal-container",
  ref: "target"
}
const _hoisted_7 = { class: "modal-header mbottom-10px" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "row w-full mbottom-10px" }
const _hoisted_10 = { class: "col-1 col-fixed-width" }
const _hoisted_11 = { styles: "main-m" }
const _hoisted_12 = { class: "modal-footer" }

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { TransportStop } from "@/apiGenerate/medserver";
import EsModal from "../modals/esModal.vue";
import { InputText } from "primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esTransportStopForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    stop: {},
    confirmMethod: { type: Function }
  },
  emits: ["modal-close", "modal-confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const nameSubmitError = ref(false);
const localStop = ref<TransportStop>({
  doctorUuid : '',
  uuid: '',
  stop: ''
})

watch (() => props.isOpen, async (isOpen) => {
  if (!isOpen) return;

  nameSubmitError.value = false;
  if (props.stop) {
    localStop.value = { ...props.stop };
  }
});

/**
 * Closes the transport stop modal with confirmation data.
 * @param isConfirmed - Whether the modal action was confirmed.
 */
const closeFormModal = () => {
  emit('modal-close');
}

const confirmFormModal = async () => {
  if (localStop.value.stop.trim().length > 0) {
    try {
      await props.confirmMethod(localStop.value);
    } catch {
      throw t('error.DEFAULT');
    }
  } else {
    nameSubmitError.value = true;
    throw t('settings.params.account.institutes.portailPatient.transportStop.nameRequired');
  }
}

const onUpdateVisible = (value: boolean) => {
  if (!value) {
    closeFormModal();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EsModal, {
      title: props.header,
      "is-open": props.isOpen,
      dismissable: "",
      "onUpdate:visible": onUpdateVisible
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_es_modal_footer, {
          onModalCancel: closeFormModal,
          confirmModalMethod: () => confirmFormModal()
        }, null, 8, ["confirmModalMethod"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "w-full transport-stop-form__field",
          "data-invalid": nameSubmitError.value
        }, [
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(t)('settings.label.instituteInformation.name')), 1),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
          ]),
          _createVNode(_unref(InputText), {
            type: "text",
            name: "name",
            id: "name",
            class: "transport-stop-form__field-input w-full",
            size: "small",
            modelValue: localStop.value.stop,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localStop.value.stop) = $event)),
            invalid: nameSubmitError.value
          }, null, 8, ["modelValue", "invalid"]),
          (nameSubmitError.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.transportStop.nameRequired')), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["title", "is-open"]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _renderSlot(_ctx.$slots, "content", {}, () => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('settings.label.instituteInformation.name')), 1)
                    ]),
                    _createVNode(_component_inputBox, { class: "col-2 w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_inputLineNew2, {
                          modelValue: localStop.value.stop,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localStop.value.stop) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _renderSlot(_ctx.$slots, "footer", {}, () => [
                  _createVNode(_component_es_modal_footer, {
                    onModalCancel: closeFormModal,
                    confirmModalMethod: () => confirmFormModal()
                  }, null, 8, ["confirmModalMethod"])
                ])
              ])
            ], 512)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})